module.exports = __webpack_public_path__ + "static/media/style1-1.3ffd8eee.gif";